/**
 * The Watch page's ticket into its live's room, asked for once and reused
 * until it is close to lapsing, so a chat socket that drops can open again at
 * once without waiting on the API. The ticket names its room.
 */
import type { LiveTicketResponse } from "../../shared/types";

/** Asked again this long before it lapses, so a socket never opens on a stale one. */
const RENEW_BEFORE_MS = 3 * 60_000;

interface TicketHolder {
  /** The ticket and its room, fresh from the API when the one held is about to lapse. */
  get: () => Promise<LiveTicketResponse>;
}

export function holdTicket(ask: () => Promise<LiveTicketResponse>, now: () => number = Date.now): TicketHolder {
  let held: LiveTicketResponse | null = null;
  let asking: Promise<LiveTicketResponse> | null = null;
  return {
    get: async () => {
      if (held && held.expires_at * 1000 - now() > RENEW_BEFORE_MS) return held;
      asking ??= ask().finally(() => {
        asking = null;
      });
      held = await asking;
      return held;
    },
  };
}
